import { makeStyles } from '@material-ui/core/styles'

const COLORS = {
  colorBlack: '#000000',
  colorWhite: '#ffffff'
}

export const useCustomTooltipStyles = makeStyles({
  tooltip: {
    backgroundColor: COLORS.colorBlack
  },
  arrow: {
    color: COLORS.colorBlack,
    "&::before": {
      backgroundColor: COLORS.colorWhite,
    }
  }
})
